import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Dialog, DialogTitle, DialogContent } from '../../../common/components';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      width: 480px;
    }
  `,
  Heading: styled.h3`
    margin-bottom: 32px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    font-weight: 500;
  `,
  ProgressBar: styled.div`
    width: 100%;
    height: 6px;
    margin-bottom: 32px;
    background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.primary.main, 0.2)};
    &::after {
      content: '';
      display: block;
      width: ${({ rate }) => `${rate * 100}%`};
      height: 100%;
      background-color: ${({ theme }) => theme.palette.primary.main};
      transition: width 0.2s;
    }
  `,
  Paragraph: styled.p`
    margin-bottom: 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    text-align: center;
    line-height: 1.53;
  `,
};

const UploadProgressDialog = ({ open, count }) => (
  <S.Dialog
    open={open}
    disableBackdropClick
    disableEscapeKeyDown
  >
    <DialogTitle>
      <S.Heading>
        연락처 업로드
      </S.Heading>
    </DialogTitle>
    <DialogContent>
      <S.ProgressBar rate={count.success / (count.total || 1)} />
      <S.Paragraph>
        {`${count.total}건 중 ${count.success}건 업로드 중...`}
        <br />
        잠시만 기다려 주세요
      </S.Paragraph>
    </DialogContent>
  </S.Dialog>
);

UploadProgressDialog.propTypes = {
  count: PropTypes.shape({
    total: PropTypes.number,
    success: PropTypes.number,
  }),
  open: PropTypes.bool.isRequired,
};

UploadProgressDialog.defaultProps = {
  count: { total: 0, success: 0 },
};

export default UploadProgressDialog;
